<template>
  <section>

<v-tabs v-model="tab" color="primary">
  <v-tab value="password">USER/PASSWORD</v-tab>
  <v-tab value="passkey">PASSKEY</v-tab>
</v-tabs>

<v-divider></v-divider>

<v-tabs-window v-model="tab">
  <!-- USER/PASSWORD -->
  <v-tabs-window-item value="password">
    <v-sheet class="pa-5">
      <form @submit.prevent="submit">
        <div class="mb-3">
          <label for="username" class="form-label">Username:</label>
          <input
            type="text"
            name="username"
            v-model="form.username"
            class="form-control"
          />
        </div>

        <div class="mb-3">
          <label for="password" class="form-label">Password:</label>
          <input
            type="password"
            name="password"
            v-model="form.password"
            class="form-control"
          />
        </div>

        <v-btn
          color="primary"
          text="Login mit Passwort"
          type="submit"
        ></v-btn>

        <div v-if="error" class="alert alert-danger mt-2">
          {{ error }}
        </div>
      </form>
    </v-sheet>
  </v-tabs-window-item>

  <!-- PASSKEY -->
  <v-tabs-window-item value="passkey">
    <v-sheet class="pa-5">

      <v-text-field
        v-model="form.username"
        label="User Name"
      ></v-text-field>


      <v-btn
        color="orange"
        text="Login mit WebAuthn"
        @click="loginWithWebAuthn"
      ></v-btn>
    </v-sheet>
  </v-tabs-window-item>
</v-tabs-window>


  </section>
</template>


<script>
import { mapActions } from 'vuex';
import axios from '@/api/client';
import { isWindowsDevelopment } from '@/config/appConfig';

export default {
  name: 'LoginScreen',
  data() {
    return {
      tab: 'passkey',   // Standard-Tab beim Laden
      form: {
        username: '',
        password: '',
      },
      error: null, // 🔹 Platz für Fehlermeldung
    };
  },
 mounted() {
    console.log('Bin login mounted',this.tab);

    // default Login Methode aktivieren
      if (isWindowsDevelopment()) {
        this.tab = 'password'
      }
 },

  methods: {
    ...mapActions(['logIn', 'viewMe']),

    // -----------------------------------
    // Klassischer Passwort-Login
    // -----------------------------------
    async submit() {
      this.error = null; // alte Fehlermeldung zurücksetzen

      const User = new FormData();
      User.append('username', this.form.username);
      User.append('password', this.form.password);

      console.log('submit(): vor logIn');

      try {
        // ⬅️ wenn Store-Login 401/422 wirft, landet es im catch
        const loggedInUser = await this.logIn(User);
        const loggedInUsername = loggedInUser?.user_username || loggedInUser?.username || this.form.username;

        console.log('submit(): Login OK, send Event');
        this.emitter?.emit('trigger-method-in-componentB', {
          msg: loggedInUsername,
        });
        this.emitter?.emit('userLoggedin', { msg: loggedInUsername });

        this.redirectAfterLogin();
      } catch (err) {
        console.error('submit(): Login fehlgeschlagen', err);

        const resp = err && err.response;
        const status = resp && resp.status;
        const data = resp && resp.data;

        if (data && data.detail) {
          this.error = `Login fehlgeschlagen: ${data.detail}`;
        } else if (status === 401 || status === 422) {
          this.error = 'Login fehlgeschlagen: Benutzername oder Passwort ist falsch.';
        } else {
          this.error = 'Login fehlgeschlagen. Bitte später erneut versuchen.';
        }

        // 🔴 GANZ WICHTIG:
        // Kein Event, kein Router-Push hier.
      }
    },

    // -----------------------------
    // Neuer: Login mit WebAuthn
    // -----------------------------
    async loginWithWebAuthn() {
      try {
        if (!window.PublicKeyCredential) {
          alert('Dieser Browser unterstützt WebAuthn nicht.');
          return;
        }

        const usernameParam = this.form.username
          ? `?username=${encodeURIComponent(this.form.username)}`
          : '';

        // 1) WebAuthn-Login-Optionen holen
        let options;
        try {
          const optionsResp = await axios.get(
            `webauthnloginoptions${usernameParam}`
          );
          options = optionsResp.data;
        } catch (err) {
          console.error('Fehler beim Laden von WebAuthn Login-Options:', err);

          const resp = err && err.response;
          const status = resp && resp.status;
          const data = resp && resp.data;

          if (data && data.detail) {
            alert(`WebAuthn-Login nicht möglich: ${data.detail}`);
          } else if (status === 404) {
            alert(
              'Für diesen Benutzer sind keine WebAuthn-Geräte registriert oder der Benutzer existiert nicht.'
            );
          } else {
            alert('WebAuthn-Login-Optionen konnten nicht geladen werden.');
          }

          return;
        }

        console.log('WebAuthn Login options:', options);

        // 2) publicKey bauen
        const challenge = this.base64urlToUint8Array(options.challenge);

        const allowCredentials = (options.allowCredentials || []).map((c) => ({
          type: c.type,
          id: this.base64urlToUint8Array(c.id),
          transports: c.transports,
        }));

        const publicKey = {
          challenge,
          rpId: options.rpId || (options.rp && options.rp.id),
          allowCredentials,
          timeout: options.timeout || 60000,
          userVerification: options.userVerification || 'preferred',
        };

        console.log('publicKey für WebAuthn get():', publicKey);
        console.log('navigator.userAgent =', navigator.userAgent);

        // 3) Assertion holen
        let assertion;
        try {
          assertion = await navigator.credentials.get({ publicKey });
        } catch (e) {
          console.error('WebAuthn error (navigator.credentials.get):', e);
          alert(`${e.name}: ${e.message}`);
          return;
        }

        if (!assertion) {
          alert('navigator.credentials.get() lieferte keine Assertion');
          return;
        }

        console.log('WebAuthn assertion:', assertion);

        // 4) Assertion konvertieren
        const credentialResponse = {
          id: assertion.id,
          rawId: this.arrayBufferToBase64url(assertion.rawId),
          type: assertion.type,
          response: {
            clientDataJSON: this.arrayBufferToBase64url(
              assertion.response.clientDataJSON
            ),
            authenticatorData: this.arrayBufferToBase64url(
              assertion.response.authenticatorData
            ),
            signature: this.arrayBufferToBase64url(
              assertion.response.signature
            ),
            userHandle: assertion.response.userHandle
              ? this.arrayBufferToBase64url(assertion.response.userHandle)
              : null,
          },
        };

        console.log('credentialResponse (Login, JSON):', credentialResponse);

        // 5) Assertion am Backend prüfen lassen
        let verifyResp;
        try {
          verifyResp = await axios.post(
            'webauthnloginverify',
            credentialResponse,
            { withCredentials: true }
          );
        } catch (err) {
          console.error('Fehler bei /webauthnloginverify:', err);

          const resp = err && err.response;
          const status = resp && resp.status;
          const data = resp && resp.data;

          if (data && data.detail) {
            alert(`WebAuthn-Login fehlgeschlagen: ${data.detail}`);
          } else if (status === 404) {
            alert(
              'Es konnte kein passendes WebAuthn-Gerät zu diesem Credential gefunden werden.'
            );
          } else if (status === 400 || status === 401) {
            alert(
              'WebAuthn-Login fehlgeschlagen. Bitte Benutzer/Gerät prüfen.'
            );
          } else {
            alert('WebAuthn-Login fehlgeschlagen (Serverfehler).');
          }

          return;
        }

        console.log('WebAuthn Login verify response:', verifyResp.data);

        // optional: User-Daten nachladen
        if (this.viewMe) {
          await this.viewMe();
        }

        // Events wie beim Passwort-Login
        if (this.emitter) {
          this.emitter.emit('trigger-method-in-componentB', {
            msg: this.form.username || '(WebAuthn)',
          });
          this.emitter.emit('userLoggedin', {
            msg: this.form.username || '(WebAuthn)',
          });
        }

        this.redirectAfterLogin();
      } catch (err) {
        console.error('WebAuthn Login error (allgemein):', err);

        if (
          err &&
          err.response &&
          err.response.data &&
          err.response.data.detail
        ) {
          alert(`Login mit WebAuthn fehlgeschlagen: ${err.response.data.detail}`);
        } else if (err && err.name && err.message) {
          alert(`${err.name}: ${err.message}`);
        } else {
          alert('Login mit WebAuthn fehlgeschlagen (unbekannter Fehler).');
        }
      }
    },

    redirectAfterLogin() {
      const redirect = this.$route?.query?.redirect;
      const queryTarget = Array.isArray(redirect) ? redirect[0] : redirect;
      const storedTarget = window.sessionStorage.getItem('authRedirectAfterLogin');
      const target = queryTarget || storedTarget;
      window.sessionStorage.removeItem('authRedirectAfterLogin');

      if (target && typeof target === 'string' && target.startsWith('/') && !target.startsWith('//')) {
        this.$router.push(target);
      } else {
        this.$router.push(this.$route.meta.shoppingLayout ? '/shopping/' : '/dashboard');
      }
    },

    // --------------------------------------------------------
    // Hilfsfunktionen für Base64url <-> ArrayBuffer
    // --------------------------------------------------------
    base64urlToUint8Array(base64urlString) {
      let base64 = base64urlString.replace(/-/g, '+').replace(/_/g, '/');
      const pad = base64.length % 4;
      if (pad) {
        base64 += '='.repeat(4 - pad);
      }
      const raw = window.atob(base64);
      const bytes = new Uint8Array(raw.length);
      for (let i = 0; i < raw.length; ++i) {
        bytes[i] = raw.charCodeAt(i);
      }
      return bytes;
    },

    arrayBufferToBase64url(buffer) {
      const bytes = new Uint8Array(buffer);
      let binary = '';
      for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      let base64 = window.btoa(binary);
      return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    },
  },
};
</script>
